
import Vue from 'vue'

export default Vue.extend({
  name: 'FormModal',
  props: {
    editData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      visible: false,
      loading: false,
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.initialData()
      }
    }
  },
  methods: {
    initialData() {
      return
    },
    trigger() {
      this.visible = !this.visible
    },
    handleSubmit() {
      return
    },
    submit() {
      this.$refs.ruleForm.validate((valid, data) => {
        if (valid) {
          // 校验通过
          this.handleSubmit()
        } else {
          return false
        }
      })
    }
  }
})
